import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import { Switch } from "../../../../../components/ui/switch";
import { Label } from "../../../../../components/ui/label";
import Field from "../../../../../components/shared/Form/Field";
import Select from "../../../../../components/shared/inputs/Select";

function Settings() {
    const { t } = useTranslation();
    const { control } = useFormContext();
    const calculateOverMultipleProfiles = useWatch({ control, name: "calculateOverMultipleProfiles" });

    return (
        <>
            <div className="tw-flex tw-items-center tw-gap-2 tw-mb-4">
                <Field name="replaceJobWhenItIsChanged" valuePropName="checked" className="tw-mb-1">
                    <Switch id="replaceJobWhenItIsChanged" />
                </Field>

                <Label className="tw-mb-1">
                    {t("replace-job-when-it-is-changed")}
                </Label>
            </div>

            <div className="tw-flex tw-items-center tw-gap-2 tw-mb-4">
                <Field name="calculateOverMultipleProfiles" valuePropName="checked" className="tw-mb-1">
                    <Switch id="calculateOverMultipleProfiles" />
                </Field>

                <Label className="tw-mb-1">
                    {t("calculate-timesheets-over-multiple-profiles")}
                </Label>
            </div>

            {calculateOverMultipleProfiles && (
                <Field
                    name="method"
                    label={t("calculation-method")}
                    required
                    rules={{
                        validate: (value) => {
                            if (!value) return t("required-calculation-method");
                            return true;
                        }
                    }}
                >
                    <Select>
                        <Select.Item value="prorated">
                            {t("prorated")}
                        </Select.Item>
                    </Select>
                </Field>
            )}

            <div className="tw-flex tw-items-center tw-gap-2 tw-mb-4">
                <Field name="hideRetroAdjustment" valuePropName="checked" className="tw-mb-1">
                    <Switch id="hideRetroAdjustment" />
                </Field>

                <Label className="tw-mb-1">
                    {t("do-not-display-retro-adjustment")}
                </Label>
            </div>

            <div className="tw-flex tw-items-center tw-gap-2 tw-mb-4">
                <Field name="syncSequentialTimesheets" valuePropName="checked" className="tw-mb-1">
                    <Switch id="syncSequentialTimesheets" />
                </Field>

                <Label className="tw-mb-1">
                    {t("keep-adjacent-timesheets-in-sync")}
                </Label>
            </div>

            <div className="tw-flex tw-items-center tw-gap-2 tw-mb-4">
                <Field name="showMandatoryBreakWarning" valuePropName="checked" className="tw-mb-1">
                    <Switch id="showMandatoryBreakWarning" />
                </Field>

                <Label className="tw-mb-1">
                    {t("show-mandatory-break-warning")}
                </Label>
            </div>
        </>
    );
}

export default Settings;
